import Cropper from "./Cropper";

Cropper.install = app => app.component(Cropper.name,Cropper)

export default Cropper
